import { WarningLevel } from 'modules/request';

export const getCellIndicatorColor = (warningLevel: WarningLevel): string => {
    switch (warningLevel) {
        case WarningLevel.None:
            return 'transparent';

        case WarningLevel.Orange:
            return '#f0984f';

        case WarningLevel.Red:
            return '#cb4e30';

        case WarningLevel.Yellow:
            return '#ffe688';

        default:
            return 'transparent';
    }
};
